import { Button, IconName, NonIdealState } from "@blueprintjs/core";
import React from "react";
import { Link } from "react-router-dom";
import { PROSPECTING_ICON } from "types/appIcons";

type BackToProspectingNonIdealStateProps = {
    readonly icon: IconName;
    readonly title: string;
    readonly description: string;
};

const BackToProspectingNonIdealState: React.FC<
    BackToProspectingNonIdealStateProps
> = ({ icon, title, description }) => {
    return (
        <NonIdealState
            icon={icon}
            title={title}
            description={description}
            action={
                <Link to="/prospecting">
                    <Button
                        icon={PROSPECTING_ICON}
                        text="Back to Prospecting"
                    />
                </Link>
            }
        />
    );
};

export default BackToProspectingNonIdealState;
